import type {AreaEffect} from "@/encounter/model/AreaEffect.ts";
import type Combatant from "@/encounter/model/Combatant.ts";

export function effectLevelId(effect: AreaEffect, combatants: readonly Combatant[]): string | undefined {
    if (!effect.combatantId) return effect.levelId;
    return combatants.find(combatant => combatant.id === effect.combatantId)?.levelId;
}

export function effectsOnLevel(
    effects: readonly AreaEffect[], combatants: readonly Combatant[], levelId?: string,
): AreaEffect[] {
    return effects.filter(effect => {
        if (effect.combatantId && !combatants.some(combatant => combatant.id === effect.combatantId)) {
            return false;
        }
        return levelId === undefined || effectLevelId(effect, combatants) === levelId;
    });
}
